/* eslint-disable react-hooks/exhaustive-deps */
import "./styles.css";
import { Grid, Link } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { SnackBarAlertContext } from "../../../../contexts/SnackbarContext";
import { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import { getValidationSchema } from "../../../../shared/validations/schema";
import { setLocalStorageData } from "../../../../shared/utils/localStorage";
import InputTextfield from "../../../../shared/components/textField";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../../../contexts/LocalStorageContext";
import { UserType } from "../../../../shared/enum";
const Login = (props: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const snackBarAlertContext = useContext(SnackBarAlertContext);
  const { updatePropertyId, updateUserData } = useLocalStorage();
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem("token");

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, navigate]);
  const textFields = [
    {
      id: "login-email",
      name: "email",
      label: "Email",
      placeholder: "Enter your email",
      type: "text",
      required: true,
    },
    {
      id: "login-password",
      name: "password",
      label: "Password",
      placeholder: "Enter your password",
      type: "password",
      required: true,
    },
  ];

  const loginForm = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: getValidationSchema(["email", "password"]),
    onSubmit: async (loginData: any) => {
      setLoading(true);

      fetch(
        // `${process.env.REACT_APP_LOGIN_GCOM_UNIFIED_API_URL}/auth/login`,
        // `${process.env.REACT_APP_API_URL}/customers/summit-login`,
        `${process.env.REACT_APP_LOGIN_GCOM_UNIFIED_API_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: loginData.email,
            password: loginData.password,
            userType: UserType.CUSTOMER,
          }),
        }
      )
        .then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json(); // Get error message from API
            throw new Error(
              errorData?.message ||
                `Error ${response.status}: ${response.statusText}`
            );
          }
          const responseType = response.headers.get("Content-Type");
          setLocalStorageData("token", response.headers.get("token"));
          if (responseType === "image/png") {
            return response.blob().then((blob) => {
              const url = URL.createObjectURL(blob);
              props.setQrCodeSrc(url);
            });
          } else {
            const data = await response.json();
            if (data.message === "Login successful") {
              try {
                const extraResponse = await fetch(
                  `${process.env.REACT_APP_API_URL}/customers`,
                  {
                    method: "GET",
                    headers: {
                      Authorization: `Bearer ${response.headers.get("token")}`,
                      "Content-Type": "application/json",
                    },
                  }
                );
                const data = await extraResponse.json();
                setLocalStorageData("userData", data);
                const defaultPropertyId = data?.propertyId || "";
                setLocalStorageData("propertyId", defaultPropertyId);
                updatePropertyId(defaultPropertyId);
                updateUserData(data);
                // Optional: store extraData in context or localStorage
              } catch (extraError) {
                console.error("Error fetching extra data:", extraError);
              }
              snackBarAlertContext.set({
                status: true,
                type: "success",
                message: data.message || "Login successful",
              });
              navigate("/dashboard");
            } else if (data.errors) {
              snackBarAlertContext.set({
                status: true,
                type: "error",
                message: data?.message,
              });
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
          snackBarAlertContext.set({
            status: true,
            type: "error",
            message: error?.message,
          });
        });
    },
  });

  return (
    <>
      <div className="loginGridContainer">
        <form
          onSubmit={loginForm.handleSubmit}
          autoComplete="off"
          className="loginForm"
        >
          {textFields.map((field: any, index: number) => {
            return (
              <InputTextfield
                className="mediumInputBox"
                form={loginForm}
                fieldProps={field}
                key={index}
              />
            );
          })}
          <Grid container>
            <Grid item md={12}>
              <Link href="/forgot-password" className="forgotPassword">
                Forgot password?
              </Link>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end">
            <Grid item md={4}>
              <LoadingButton
                className="signInButton"
                loading={loading}
                variant="contained"
                type="submit"
                fullWidth
                size="small"
              >
                Login
              </LoadingButton>
            </Grid>
          </Grid>
        </form>
      </div>
    </>
  );
};

export default Login;
